import { Slot } from '@radix-ui/react-slot'
import { ChevronRight, MoreHorizontal } from 'lucide-react'
import PropTypes from 'prop-types'

import { cn } from '@/utils/helpers'

function Breadcrumb({ ...props }) {
  return <nav aria-label="breadcrumb" data-slot="breadcrumb" {...props} />
}

function BreadcrumbList({ className = '', ...props }) {
  return (
    <ol
      data-slot="breadcrumb-list"
      className={cn(
        'text-muted-foreground flex flex-wrap items-center gap-1.5 text-sm break-words sm:gap-2.5',
        className,
      )}
      {...props}
    />
  )
}

BreadcrumbList.propTypes = {
  className: PropTypes.string,
}

function BreadcrumbItem({ className = '', ...props }) {
  return (
    <li
      data-slot="breadcrumb-item"
      className={cn('inline-flex items-center gap-1.5', className)}
      {...props}
    />
  )
}

BreadcrumbItem.propTypes = {
  className: PropTypes.string,
}

function BreadcrumbLink({ asChild, className = '', ...props }) {
  const Comp = asChild ? Slot : 'a'

  return (
    <Comp
      data-slot="breadcrumb-link"
      className={cn('hover:text-foreground transition-colors', className)}
      {...props}
    />
  )
}

BreadcrumbLink.propTypes = {
  asChild: PropTypes.bool,
  className: PropTypes.string,
}

function BreadcrumbPage({ className = '', current = true, ...props }) {
  return (
    <span
      data-slot="breadcrumb-page"
      role="link"
      aria-disabled="true"
      aria-current={current ? 'page' : undefined}
      className={cn('text-foreground font-normal', className)}
      {...props}
    />
  )
}

BreadcrumbPage.propTypes = {
  className: PropTypes.string,
  current: PropTypes.bool,
}

function BreadcrumbSeparator({ children = null, className = '', ...props }) {
  return (
    <li
      data-slot="breadcrumb-separator"
      role="presentation"
      aria-hidden="true"
      className={cn('[&>svg]:size-3.5', className)}
      {...props}
    >
      {children ?? <ChevronRight />}
    </li>
  )
}

BreadcrumbSeparator.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

function BreadcrumbEllipsis({ className, ...props }) {
  return (
    <span
      data-slot="breadcrumb-ellipsis"
      role="presentation"
      aria-hidden="true"
      className={cn('flex size-9 items-center justify-center', className)}
      {...props}
    >
      <MoreHorizontal className="size-4" />
      <span className="sr-only">More</span>
    </span>
  )
}

BreadcrumbEllipsis.propTypes = {
  className: PropTypes.string,
}

export {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
  BreadcrumbEllipsis,
}
